class Util {
  static buildCommandStringLCU(code, lcuCode, replyQueue) {
    return code + Util.formatThreeDigit(lcuCode) + replyQueue;
  }

  static buildCommandStringGCU(code, replyQueue) {
    return `${code}000${replyQueue}`;
  }

  static buildCommandStringAllLCU(code, replyQueue) {
    return `${code}998${replyQueue}`;
  }

  static formatThreeDigit(input) {
    const output = input.padStart(3, '0');
    return output;
  }
}

export default Util;
